<template lang='pug'>
  .newsletter-signup-page
    .main-container
      h1 Newsletter Signup
      signupForm(:stand-alone="true")
</template>

<script>
import signupForm  from '@/js/components/footer/desktop-newsletter-signup.vue'

export default {
  name       : 'page-newsletter-signup',
  components : {
    signupForm,
  },
}
</script>
<style scoped lang="scss">
  .main-container {
    margin-top: $space-xxxl;
    max-width: $tablet;
  }
</style>
